import { isENSNameFormatIgnoreCase } from './ENSName';
export function isENSName(domain) {
    return isENSNameFormatIgnoreCase(domain);
}
